import deposit from '../../fields/cases/deposit';

export const QUERY_GET_D_CASE = /* GraphQL */ `
	query($id: String!) {
		getDepositCase(id: $id) {
			${deposit}
		}
	}
`;
